import React from 'react';

const escapeRegExp = (value) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Case-insensitive substring highlight for result titles (tier 1 signal).
 */
export const highlightMatch = (text, searchTerm) => {
  if (!text) return text;
  const trimmed = searchTerm?.trim();
  if (!trimmed) return text;

  const parts = String(text).split(new RegExp(`(${escapeRegExp(trimmed)})`, 'gi'));
  return parts.map((part, index) =>
    part.toLowerCase() === trimmed.toLowerCase() ? (
      <mark key={index} className="bg-yellow-200 text-inherit rounded-sm px-0.5">
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export const resultItemKey = (item) => `${item.kind}:${item.id}`;
